import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {BaseWebservice} from '../../../shared/base/base.webservice';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from "sweetalert2";
import {Content} from '../../../shared/content/content.txt';
import {AuthService} from '../../../modules/auth';
import { StripeService } from 'ngx-stripe';
import { ProcessService } from '../../_services/process.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-finish-process',
  templateUrl: './finish-process.component.html',
  styleUrls: ['./finish-process.component.scss']
})
export class FinishProcessComponent implements OnInit {
    BRONZEPLANAMOUNT = 6900;
    SILVERPLANAMOUNT = 14900;
    GOLDPLANAMOUNT = 79900
    content: Content
    processListing = []
    handler: any;
    loading = false
    elements
    details
    plan = null
    plan_paid = false
    templateText = {
        heading: 'Which Will is right for you? WiserNow has a plan to suit every need.',
        subHeading: 'Choose from our range of Wills, with options including our completely free Bronze package,<br> right through to catering for the most bespoke and customised of needs.',
        bronzePlanHeading: 'Our popular free Will plan! Edit your draft Will until it is published, however no changes can be made once your Will is completed.',
        silverPlanHeading: 'Unlimited edits on your Will, forever, as well as legal validation from our specialist Wills team.',
        goldPlanHeading: 'All the benefits of the Silver plan, with the ability to include bespoke needs into your Will.'
    }
    bronzeText = {
        heading: 'One last thing!',
        subHeading: 'Upgrade your free Will and make an even wiser decision.',
        bronzePlanHeading: 'Edit your draft Will until it is published, however no changes can be made once your Will is completed.',
        silverPlanHeading: 'Unlimited edits on your Will, forever, as well as legal validation from our specialist Wills team.',
        goldPlanHeading: 'All the benefits of the Silver plan, with the ability to include bespoke needs into your Will.'
    }
    silverText = {
        heading: 'One last thing!',
        subHeading: 'Upgrade your Silver Will and ensure your legacy is left just as you wanted it.',
        bronzePlanHeading: 'Edit your draft Will until it is published, however no changes can be made once your Will is completed.',
        silverPlanHeading: 'Unlimited edits on your Will, forever, as well as legal validation from our specialist Wills team.',
        goldPlanHeading: 'All the benefits of the Silver plan, with the ability to include bespoke needs into your Will.'
    }
    goldText = {
        heading: 'One last step!',
        subHeading: 'You’ve selected our Gold Will! Submit your Will below and our legal team will be in touch shortly to discuss your specific needs.',
        bronzePlanHeading: 'Edit your draft Will until it is published, however no changes can be made once your Will is completed.',
        silverPlanHeading: 'Unlimited edits on your will, forever, as well as legal validation from our specialist wills team.',
        goldPlanHeading: 'All the benefits of the Silver plan, with the ability to include bespoke needs into your Will.'
    }
    // @ViewChild(StripePaymentElementComponent) paymentElement: StripePaymentElementComponent
  constructor(

      private _globalService: BaseWebservice,
      private route: ActivatedRoute,
      private router: Router,
      private _cd:ChangeDetectorRef,
      private authService: AuthService,
      private stripeService: StripeService,
      private processService: ProcessService

  ) {

      this.processListing = _globalService.getCompleteProcess()
  }

  ngOnInit(): void {
    this.processService.getUserDetails().subscribe(response => {
        if(response['success'] == true) {
            this.details = response['data']
            this.plan = response['data'].plan
            this._globalService.plan = this.plan
            this.plan_paid = response['data'].paid
            this._globalService.plan_paid = this.plan_paid
            switch (this.plan) {
                case '0':
                    this.templateText = this.bronzeText;
                    break;
                case '1':
                    this.templateText = this.silverText;
                    break;
                case '2':
                    this.templateText = this.goldText;
                    break;
                default:
                    this.templateText = this.bronzeText;
                    break;
            }
        } else {
        }
    })
  }

  checkoutbronze() {
    // this.processService.createPayment({token:null, plan: '0'}).subscribe(response => {
    //     if(response['success']) {
    //         this._globalService.plan = 0
    //         this._globalService.plan_paid = true;
    //         this.navigateToNextPage()
    //     }
    // })
    let planInt = 0
      if(planInt == 0 && this.plan_paid){
        // return this.processService.send_legal_email_prepaid({plan: '1'}).subscribe(response => {
            // if(response['success']) {
                this.router.navigate([`/download`])
                return
            // }
        // })
      }

    this.handler = (<any>window).StripeCheckout.configure({
        key: environment.stripeKey,
        // image: '/your-avatar.png',
        locale: 'auto',
        // source: async (source) => {
        //   this.loading = true;
        // //   const user = await this.auth.getUser();
        // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
        // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
        // //   this.loading = false;
        token: (token: any, args: any) => {
            this.processService.createPayment({token, plan: '0'}).subscribe(response => {
                if(response['success']) {
                    this._globalService.plan = 0
                    this._globalService.plan_paid = true;
                    this.navigateToNextPage()
                }
            })
        }
        // }
      });
      this.handler.open({
        name: 'WiserNow Bronze Plan',
        // description: 'Card Details',
        email: this.details?.email,
        amount: this.BRONZEPLANAMOUNT,
        currency: 'aud'
    });
  }

  checkoutsilver(plan, number) {

      let planInt = + plan
      if(planInt == number && this.plan_paid){
        return this.processService.send_legal_email_prepaid({plan: '1'}).subscribe(response => {
            if(response['success']) {
                this.router.navigate([`/download`])
                return
            }
        })
      }

    this.handler = (<any>window).StripeCheckout.configure({
        key: environment.stripeKey,
        // image: '/your-avatar.png',
        locale: 'auto',
        // source: async (source) => {
        //   this.loading = true;
        // //   const user = await this.auth.getUser();
        // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
        // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
        // //   this.loading = false;
        token: (token: any, args: any) => {
            this.processService.createPayment({token, plan: '1'}).subscribe(response => {
                if(response['success']) {
                    this._globalService.plan = 1
                    this._globalService.plan_paid = true;
                    this.navigateToNextPage()
                }
            })
        }
        // }
      });
      this.handler.open({
        name: 'WiserNow Silver Plan',
        // description: 'Card Details',
        email: this.details?.email,
        amount: this.SILVERPLANAMOUNT,
        currency: 'aud'
    });


  }
  checkoutGold(plan,number) {

      let planInt = + plan
      if(planInt == number  && this.plan_paid){
        return this.processService.send_legal_email_prepaid({plan: '2'}).subscribe(response => {
            if(response['success']) {
                this.router.navigate([`/download`])
                return
            }
        })
      }


      this.handler = (<any>window).StripeCheckout.configure({
        key: environment.stripeKey,
        // image: '/your-avatar.png',
        locale: 'auto',
        // source: async (source) => {
        //   this.loading = true;
        // //   const user = await this.auth.getUser();
        // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
        // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
        // //   this.loading = false;
        token: (token: any, args: any) => {
            this.processService.createPayment({token, plan: '2'}).subscribe(response => {
                if(response['success']) {
                    this._globalService.plan = 2
                    this._globalService.plan_paid = true;
                    this.navigateToNextPage()
                }
            })
        }
        // }
      });
      if(this.plan == "1") {
        this.handler.open({
            name: 'WiserNow Gold Plan',
            // description: 'Card Details',
            email: this.details?.email,
            amount: this.GOLDPLANAMOUNT - this.SILVERPLANAMOUNT,
            currency: 'aud'
        });
    } else {
        this.handler.open({
            name: 'WiserNow Gold Plan',
            // description: 'Card Details',
            email: this.details?.email,
            amount: this.GOLDPLANAMOUNT,
            currency: 'aud'
        });
    }
  }
//   checkoutgold() {
//     this.handler = (<any>window).StripeCheckout.configure({
//         key: environment.stripeKey,
//         // image: '/your-avatar.png',
//         locale: 'auto',
//         // source: async (source) => {
//         //   this.loading = true;
//         // //   const user = await this.auth.getUser();
//         // //   const fun = this.functions.httpsCallable('stripeCreateCharge');
//         // //   this.confirmation = await fun({ source: source.id, uid: user.uid, amount: this.amount }).toPromise();
//         // //   this.loading = false;
//         token: (token: any, args: any) => {
//             this.processService.createPayment({token, plan: '2'}).subscribe(response => {
//                 if(response['success']) {
//                     this._globalService.plan = 2
//                     this.navigateToNextPage()
//                 }
//             })
//         }
//         // }
//       });
//       if(this.plan == "1") {
//         this.handler.open({
//             name: 'Wisernow Gold Plan',
//             // description: 'Card Details',
//             email: this.details?.email,
//             amount: this.GOLDPLANAMOUNT - this.SILVERPLANAMOUNT,
//             currency: 'aud'
//         });
//       } else {
//           this.handler.open({
//             name: 'Wisernow Gold Plan',
//             // description: 'Card Details',
//             email: this.details?.email,
//             amount: this.GOLDPLANAMOUNT,
//             currency: 'aud'
//         });
//       }
//   }


    navigateToNextPage() {

        this.router.navigate([`/download`])

    }

    endSession() {
        this.authService.logout()
        this._globalService.setDataAsdefault()
    }


    navigateToStep(id: string) {

        this.router.navigate([`/${id}`])
        setTimeout(args =>
                this._cd.detectChanges()
            ,500)

    }

    getFinishedItem(item: any,list, index) {

        let itemsFinised = list.filter(v => v.isFinished == true);

        if(item.isFinished) return true; else if (itemsFinised.length >0) return itemsFinised.length == index;


    }

    navigateToPage(item, index, listing) {

        if(index ==0){
            this.router.navigate([`/${item.id}`])
        }else{
            let previousSelectedItem = listing[index-1]

            if (previousSelectedItem.isFinished) {
                this.router.navigate([`/${item.id}`])
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-left',
                    iconColor: 'white',
                    customClass: {
                        popup: 'colored-toast'
                    },
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                })
                Toast.fire({
                    icon: 'info',
                    title: 'You need to complete previous step before you try to fill  ' + item.label
                })
            }

        }



    }

    expandAccordian(item: any) {

        return item.id == this.activeId
    }

    activeId: string = "";

    toggleAccordian(event) {
        // If it is already open you will close it and if it is closed open it
        this.activeId = this.activeId == event.panelId ? "" : event.panelId;
    }

    getIcon(key, status) {
        let base = "./assets/media/steps/";
        if (status) {
            if (key == "aboutyou") {

                base = base + "step1-active.svg"

            } else if (key == "executor") {
                base = base + "step2-active.svg"

            } else if (key == "estate") {
                base = base + "step3-active.svg"

            } else if (key == "gifts") {
                base = base + "step4-active.svg"

            } else if (key == "funeralwishes") {
                base = base + "step5-active.svg"

            }


        } else {
            if (key == "aboutyou") {

                base = base + "step1-inactive.svg"

            } else if (key == "executor") {
                base = base + "step2-inactive.svg"

            } else if (key == "estate") {
                base = base + "step3-inactive.svg"

            } else if (key == "gifts") {
                base = base + "step4-inactive.svg"

            } else if (key == "funeralwishes") {
                base = base + "step5-inactive.svg"

            }
        }

        return base
    }

    getCtaButtonText(val, defaultValue){
        console.log(val,defaultValue)
        if(val == null) return "Complete your Will"

        let valInt  =  + val
        if(valInt< defaultValue) return  "Upgrade your Will"
        else  if (valInt ==  defaultValue) return  "Complete your will"
        else return "Not Applicable"


    }

    getPlan(plan: any, number: number) {

    }

    goToDashboard(){

        window.open(
            'https://www.wisernow.com.au', '_blank' /* */);

    }
}
